import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

export default function DaemonSets() {
  return (
    <PagedWorkloadPage
      title="DaemonSets" kind="DaemonSet" resource="daemonsets" label="daemonsets"
      deletable restartable
      cols={['Name', 'Namespace', 'Desired', 'Ready', 'Age']}
      renderRow={d => [
        <td key="n"><Code>{d.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{d.namespace}</td>,
        <td key="d">{d.desired}</td>,
        <td key="r" style={{
          color: d.ready === d.desired ? 'var(--color-success-500)' : 'var(--color-danger-500)',
          fontWeight: 600,
        }}>{d.ready}</td>,
        <td key="a"><Age ts={d.created_at} /></td>,
      ]}
    />
  );
}
